export enum studentDetailActionTypes {
  SET_STUDENT_DETAIL = 'SET_STUDENT_DETAIL',
  SET_STUDENT_ID_ENABLE = 'SET_STUDENT_ID_ENABLE',
  UPDATE_STUDENT_ID_ENABLE = 'UPDATE_STUDENT_ID_ENABLE',
  CLEAR_STUDENT_ID = 'CLEAR_STUDENT_ID',
}
